'use strict';

exports.__esModule = true;

var _scrollProp, _sizeProp, _positionProp;

var ALIGN_START = exports.ALIGN_START = 'start';
var ALIGN_CENTER = exports.ALIGN_CENTER = 'center';
var ALIGN_END = exports.ALIGN_END = 'end';
var DIRECTION_VERTICAL = exports.DIRECTION_VERTICAL = 'vertical';
var DIRECTION_HORIZONTAL = exports.DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_CHANGE_OBSERVED = exports.SCROLL_CHANGE_OBSERVED = 'observed';
var SCROLL_CHANGE_REQUESTED = exports.SCROLL_CHANGE_REQUESTED = 'requested';

var scrollProp = exports.scrollProp = (_scrollProp = {}, _scrollProp[DIRECTION_VERTICAL] = 'scrollTop', _scrollProp[DIRECTION_HORIZONTAL] = 'scrollLeft', _scrollProp);
var sizeProp = exports.sizeProp = (_sizeProp = {}, _sizeProp[DIRECTION_VERTICAL] = 'height', _sizeProp[DIRECTION_HORIZONTAL] = 'width', _sizeProp);
var positionProp = exports.positionProp = (_positionProp = {}, _positionProp[DIRECTION_VERTICAL] = 'top', _positionProp[DIRECTION_HORIZONTAL] = 'left', _positionProp);


//////////////////
// WEBPACK FOOTER
// ./~/react-tiny-virtual-list/lib/constants.js
// module id = 354
// module chunks = 0